import { type FC, type ReactNode } from 'react';
import classnames from 'classnames';

import styles from './HpSharedCarouselTabsHeader.scss';
import dibsCss from 'dibs-css';

type Props = {
    title?: ReactNode;
    collectionTitle?: ReactNode;
    dataTn?: string;
    size?: 'large' | 'larger';
    align?: 'center' | 'left';
};

export const HpSharedCarouselTabsHeader: FC<Props> = ({
    title,
    collectionTitle,
    dataTn,
    size = 'large',
    align = 'center',
}) =>
    title ? (
        <div
            className={classnames(
                styles.headerContainer,
                styles[size],
                {
                    [dibsCss.textLeft]: align === 'left',
                    [dibsCss.textCenter]: align === 'center',
                },
                size === 'large' && [dibsCss.mxLarge, dibsCss.mtLarge, dibsCss.mbMedium],
                size === 'larger' && [
                    dibsCss.mxLarger,
                    dibsCss.mtLarger,
                    dibsCss.mbMedium,
                    dibsCss.textNoir,
                ]
            )}
        >
            <span
                className={classnames(
                    styles.title,
                    styles[size],
                    { [dibsCss.sassyFontHeaderSizeLargeTypeNormal]: size === 'large' },
                    { [dibsCss.sassyFontHeaderSizeXLargeTypeNormal]: size === 'larger' }
                )}
                data-tn={dataTn ? `${dataTn}-title` : null}
            >
                {title}
                {collectionTitle && <span>: </span>}
            </span>
            <span
                className={classnames(
                    { [dibsCss.sassyFontHeaderSizeLargeTypeItalic]: size === 'large' },
                    { [dibsCss.sassyFontHeaderSizeXLargeTypeItalic]: size === 'larger' }
                )}
                data-tn={dataTn ? `${dataTn}-collection-title` : null}
            >
                {collectionTitle}
            </span>
        </div>
    ) : null;
